import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { withRouter } from "react-router"

import { getUserData } from "../sessionStorage";

import LoggedInMenu from "./LoggedInMenu";
import OcrProcessDropzone from "./OcrProcessDropzone";
import SummaryTable from "./SummaryTable";
import BuildInfo from "./BuildInfo";

import UploaderButton from "./UploaderButton";
import SearchButton from "./SearchButton";

interface IStartPageProps {
  history: any;
  location: any;
  match: any;
}

class StartPage extends React.Component<IStartPageProps> {
  state: {
    showModal: boolean;
    userFullName: string;
  };

  constructor(props: any) {
    super(props);

    this.state = {
      showModal: false,
      userFullName: "",
    };
  }

  componentDidMount() {
    const userData = getUserData();
    if (userData) {
      let fullName = JSON.parse(userData).fullName;
      this.setState({ userFullName: fullName || "" });
    }
  }

  render() {
    return (
      <>
        <LoggedInMenu history={this.props.history} />
        <OcrProcessDropzone
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
        />
        <div className="content-wrapper">
          <Container fluid>
            <Row>
              <Col xs={12} lg={10} className="main">
                <div className="contentheader">
                  <Container fluid>
                    <Row className="align-items-stretch py-3">
                      <Col xs={6} lg={7}>
                        <UploaderButton
                          onClick={() =>
                            this.setState({
                              ...this.state,
                              showModal: true,
                            })
                          }
                        />
                      </Col>
                      <Col xs={6} lg={5}>
                        <SearchButton
                          history={this.props.history}
                        ></SearchButton>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <SummaryTable />
              </Col>
              {/*
              <Col xs={12} lg={2} className="sidebar">
                <Row className="py-2">
                  <Col xs={4} lg={12} className="my-2">
                    <a
                      href="#"
                      className="container bg-white bshadow text-center p-3 br-lg cta-box"
                    >
                      <h5>Noch zu zahlen</h5>
                      <p className="fw-600 fs-3">
                        23,50<span className="fs-075">€</span>
                      </p>
                    </a>
                  </Col>
                  <Col xs={4} lg={12} className="my-2">
                    <Container className="bg-white bshadow text-center p-3 br-lg cta-box">
                      <Row className="no-gutters">
                        <Col xs={12} className="text-center">
                          <h4>Termine</h4>
                        </Col>
                        <Col xs={6} className="align-self-center">
                          <a className="dbw100 mb-0 fw-600 fs-3 badge" href="#">
                            <span className="icon-search" />
                          </a>
                        </Col>
                        <Col xs={6} className="align-self-center">
                          <a className="dbw100 mb-0 fw-600 fs-3 badge" href="#">
                            <span className="icon-attention-1" />
                          </a>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                  <Col xs={4} lg={12} className="my-2">
                    <a
                      href="#"
                      className="container bg-white bshadow text-center p-3 br-lg cta-box"
                    >
                      <h4>Erstattet</h4>
                      <p className="fw-600">
                        <span className="fs-3">123,50</span>
                        <span className="fs-2">€</span>
                      </p>
                    </a>
                  </Col>
                </Row>
              </Col>
              */}
            </Row>
            <BuildInfo/>
          </Container>
        </div>
      </>
    );
  }
}

export default withRouter(StartPage);
